import { api } from '../client';
import { unwrap } from '../unwrap';
import { putPresignedObject } from '../presignedUpload';

export interface UploadUrlResponse {
  recording_id: string;
  upload_url: string;
  file_url: string;
  expires_in: number;
  headers?: Record<string, string>;
}

export interface ConfirmUploadResponse {
  id: string;
  title: string | null;
  duration: number | null;
  status: string;
  file_name: string;
  file_size: number | null;
  file_url: string;
  created_at: string;
  updated_at: string;
}

export const recordingsApi = {
  async getUploadUrl(fileName: string, contentType: string): Promise<UploadUrlResponse> {
    const raw = await api.post<unknown>('/api/v1/recordings/upload-url', {
      file_name: fileName,
      content_type: contentType,
    });
    return unwrap<UploadUrlResponse>(raw);
  },

  async putToOss(
    uploadUrl: string,
    blob: Blob,
    contentType: string,
    headers?: Record<string, string>
  ): Promise<void> {
    const res = await putPresignedObject({
      uploadUrl,
      body: blob,
      contentType,
      headers,
    });
    if (!res.ok) throw new Error(`OSS upload failed: HTTP ${res.status}`);
  },

  async confirmUpload(
    recordingId: string,
    params: { file_size?: number; duration?: number } = {}
  ): Promise<ConfirmUploadResponse> {
    const raw = await api.post<unknown>(
      `/api/v1/recordings/${recordingId}/confirm-upload`,
      undefined,
      { query: params }
    );
    return unwrap<ConfirmUploadResponse>(raw);
  },
};
